import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import { CREATE_CUSTOM_ROLE_TEXT } from '@modules/Roles/constants/roles';

interface Props {
  label?: string;
  onClick?: ButtonProps['onClick'];
}

const CreateRoleButton: React.FC<Props> = ({ label, onClick }) => {
  return (
    <Button type="primary" icon={<PlusOutlined />} onClick={onClick}>
      {label || CREATE_CUSTOM_ROLE_TEXT}
    </Button>
  );
};

export default CreateRoleButton;
